import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Premium-feel defaults: navigations from cache are instant.
      staleTime: 30_000,            // 30s — most lists are fine for half a minute
      gcTime: 5 * 60_000,           // keep cache 5 min after unmount
      refetchOnWindowFocus: false,  // don't blink data on focus
      retry: (count, err) => {
        // No retry on auth/forbidden; one retry on transient errors.
        const status = (err as { response?: { status?: number } })?.response?.status;
        if (status && [401, 403, 404].includes(status)) return false;
        return count < 1;
      },
    },
    mutations: {
      retry: 0,
    },
  },
});
